<template>
  <PortalPageShell
    title="Check-in Rows Manager"
    :subtitle="$t('portal.checkinManager')"
  >
    <ManageCheckinRow
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageCheckinRow from '../components/checkin/ManageCheckinRow.vue';

export default {
  components: {
    PortalPageShell,
    ManageCheckinRow,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
